<template>
  <div class="margin-bottom-lg">
    <div class="row align-stretch">
      <div
        v-for="feature in features"
        :key="feature.id"
        :class="featureClass"
      >
        <component
          :is="feature.location.href ? 'a' : 'site-link'"
          v-bind="getLocationProps(feature)"
          :class="setFeatureCardClass(feature.theme)"
          style="--card-link-box-shadow-color: var(--card-link-hover-border-color); height: 100%"
          @click="handleFeatureClick(feature)"
        >
          <div
            class="header padding-0 position-relative"
            style="min-height: var(--feature-image-min-height, 15rem); overflow: hidden"
          >
            <img
              :src="`/images/icons/features/${feature.image}`"
              alt=""
              aria-hidden
              style="width: 100%; height: 100%; object-fit: cover; object-position: center; display: block"
            />
          </div>
          <div
            class="header"
            style="--card-header-border: none; flex: 1 0 auto"
          >
            <h3
              class="h5 margin-bottom-md text-uppercase"
              style="letter-spacing: var(--letter-spacing-2xl)"
            >
              {{ feature.title }}
            </h3>
            <p>{{ feature.description }}</p>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
  import { featureLinksMixin } from '../mixins'

  export default {
    name: 'IconsFeatures',

    mixins: [featureLinksMixin],

    props: {
      features: {
        type: Array,
        required: true
      }
    },

    computed: {
      featureClass() {
        return `column-12 margin-bottom-lg laptop:margin-bottom-0 laptop:column`
      }
    },

    methods: {
      setFeatureCardClass(theme) {
        return `card roomy margin-0 text-left display-flex flex-column ${theme}`
      }
    }
  }
</script>
